import { useEffect } from "react";
import { History } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { fmtDateTime, label } from "@/lib/format";

const val = (v) => (v === null || v === undefined || v === "" ? "∅" : typeof v === "object" ? JSON.stringify(v) : String(v));

export const AuditMeta = ({ record }) =>
  record ? (
    <div className="text-xs text-slate-500 font-mono flex flex-wrap gap-x-6 gap-y-1" data-testid="audit-meta">
      <span>Created by {record.created_by?.name} · {fmtDateTime(record.created_at)}</span>
      <span>Updated by {record.updated_by?.name} · {fmtDateTime(record.updated_at)}</span>
    </div>
  ) : null;

export function AuditPanel({ entityId, refreshKey }) {
  const { data, reload } = useFetch(entityId ? `/audit-logs?entity_id=${entityId}` : null);
  useEffect(() => {
    reload();
  }, [refreshKey, reload]);
  if (!data) return null;
  return (
    <div className="space-y-0" data-testid="audit-log-list">
      {data.length === 0 && <div className="text-sm text-slate-500">No history yet.</div>}
      {data.map((a) => (
        <div key={a.id} className="flex gap-3 py-2.5 border-b border-slate-100 last:border-0">
          <History className="h-4 w-4 text-slate-400 mt-0.5 shrink-0" />
          <div className="min-w-0 flex-1">
            <div className="text-sm text-slate-800">
              <span className="font-medium">{a.by?.name}</span>{" "}
              <span className="uppercase text-[11px] font-mono text-sky-700">{label(a.action)}</span>
              {a.note && <span className="text-slate-600"> — {a.note}</span>}
            </div>
            {Object.entries(a.changes || {}).map(([k, c]) => { const [o, n] = Array.isArray(c) ? c : [null, c]; return (
              <div key={k} className="text-xs font-mono text-slate-500 break-all">
                {k}: <span className="line-through text-red-500/80">{val(o)}</span> → <span className="text-emerald-700">{val(n)}</span>
              </div>
            ); })}
            <div className="text-[11px] text-slate-400 font-mono">{fmtDateTime(a.at)}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
